<template>
  <div >
    <div
      class="flex items-center cursor-pointer pl-2"
      @click="isDomainFormModal = true"
    >
      <p class="text-xl font-bold text-darkBlue">
        Add
      </p>
      <img src="./icons/add.svg" alt="add icon" class="pl-2" />
    </div>
    <div class="table-wrapper mt-2" id="table-wrapper">
      <table class="custom-table responsive-table m-0">
        <thead>
          <tr>
            <th>
              <!-- <base-checkbox v-model="selectAll" /> -->
            </th>
            <th>Name</th>
            <!-- <th>Domain Name</th>  -->
            <th>Email Address</th>

            <th> 
              <div class="flex justify-end items-center mr-6">
                <img
                  src="@/assets/images/icons/table-action.svg"
                  alt="actions"
                />
              </div>
            </th>
          </tr>
        </thead>
        <tbody v-if="computedDomains">
          <tr v-for="domain in computedDomains" :key="domain.id">
            <td>
              <!-- <base-checkbox v-model="selecteddomains" :value="domain.id" /> -->
            </td>
            <td>{{ domain.name }}</td>
            <td>{{ domain.email }}</td>
            <!-- <td>{{ domain.country }}</td> -->
            <!-- <td class="capitalize">{{ domain.type }}</td>
            <td class="text-center">0</td> -->

            <td class="flex items-center cursor-pointer">
              <span class="flex items-center" @click="editDomain(domain)">
                <span><img src="./icons/edit.svg" alt="edit icon"/></span>
                <span class="pl-1">Edit</span>
              </span>
              <span
                class="flex items-center px-2"
                @click="(selectedDomain = domain), (isDeleteModal = true)"
              >
                <span><img src="./icons/delete.svg" alt="edit icon"/></span>
                <span class="pl-1">Remove</span>
              </span>
              <!-- <span class="flex items-center" @click="viewDomain(domain)">
                <span><img src="./icons/eye.svg" alt="edit icon"/></span>
                <span class="pl-1"> View domain</span>
              </span> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="!domains.length">
      <empty-state description="No domains Found!" />
    </div>

    <div class="px-2" v-if="domains.length">
      <pagination />
    </div>

    <domain-form
      :show-modal="isDomainFormModal"
      @close-modal="isDomainFormModal = false"
      :selectedsubDomainDetails="selectedDomain"
      @domain-created="getAllDomains"
    />

    <delete-modal
      :show-modal="isDeleteModal"
      @close-modal="isDeleteModal = false"
      :domain="selectedDomain"
      @domain-deleted="getAllDomains"
    />
  </div>
</template>

<script>
import Pagination from "@/components/UI/NewPagination";
import DomainForm from "./Modals/DomainForm";
import DeleteModal from "./Modals/DeleteModal";


export default {
  components: {
    Pagination,
    DomainForm,
    DeleteModal,
  },

  data() {
    return {
      domains: [],
      isDomainFormModal: false,
      isPrimary: true,
      isDeleteModal: false,
      selectedDomain: null,
      center: {},
      isMapModal: false,
      loading: false,
      selecteddomains: [],
      selectAll: false,
    };
  },
  watch: {
    selectAll(value) {
      if (value) {
        this.domains.forEach((domain) => {
          this.selecteddomains.push(domain.id);
        });
      } else {
        this.selecteddomains = [];
      }
    },
  },
  computed:{
    computedDomains(){
      return this.domains.filter(d => d != null)
    }
  },
  mounted() {
    this.getAllDomains();
  },
  methods: {
    async getAllDomains() {
      this.loading = true;
      try {
        const response = await this.$_getAllDomains();
        this.log(response);
        this.loading = false;
        if(response.data.data.userDomains != null){
          this.domains =  response.data.data.userDomains.subDomains 
        } else {
          this.domains =  [];
        }
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    async updateDefaultDomain(value, locationId) {
      this.loading = true;
      console.log(value, locationId);

      try {
        const response = await this.$_setDefaultDomain(locationId);
        this.getAllDomains();
        this.log(response);
        this.generateToast("Domain has been set as default!", "success");
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    editDomain(domain) {
      this.selectedDomain = domain;
      this.isDomainFormModal = true;
    },
    viewDomain(domain) {
      this.center = {
        lat: domain.address.lat,
        lng: domain.address.lng,
      };
      this.isMapModal = true;
    },
  },
};
</script>

<style scoped>
tr {
  box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
}
th {
  color: #7a90a7;
  font-size: 0.9rem;
  font-weight: normal;
}
th,
td {
  padding: 0.5rem;
}
td {
  color: #383f51;
  font-weight: 600;
}
table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}
</style>
